export enum ActionSource {
  SUMMARY_OVERVIEW = 'Summary Overview',
  INVENTORY = 'Inventory',
  CREATE_INVENTORY = 'Create Inventory',
  WORKORDERS = 'Work Orders',
  ACTIVITY = 'Activity',
  MUTATE_OBJECT_DIALOG = 'Mutate Object Dialog',
  MUTATE_CHARGE_DIALOG = 'Mutate Charge Dialog',
  MUTATE_DISCOUNT_DIALOG = 'Mutate Discount Dialog',
  ADD_DISCOUNTS_DIALOG = 'Add Discounts Dialog',
  NEW_OPPORTUNITY = 'New Opportunity',
  LEAVE_CONFIRMATION_DIALOG = 'Leave Confirmation Dialog',
  JOB_TAGS = 'Job Tags',
  JOB_FINANCIALS = 'Job Financials',
  JOB_STATUS_DROPDOWN = 'Job Status Dropdown',
  JOB_HEADER = 'Job Header',
  JOB_TOOL = 'Job Tool',
  JOB_MANUALLY_ADD_LOCATION = 'Job Manually Add Location',
  JOB_TOOL_SUBSCRIPTION = 'Job Tool Subscription',
  JOB_ESTIMATE = 'Job Estimate',
  JOB_CREATE_LOCATIONS = 'Job Create Locations',
  JOB_FORM_ACTION_BUTTON = 'Job Form Action Button',
  JOB_DOCUMENTS = 'Job Documents',
  JOB_EDIT = 'Job Edit',
  JOB_INVOICE = 'Job Invoice',
  CUSTOMER_EDITOR = 'Customer Editor',
  CLOSE_JOB_COMPONENT = 'Close Job Component',
  JOB_TIMELINE_AVAILABILITY = 'Job Timeline Availability',
  DISCARD_OPPORTUNITY_DIALOG = 'Discard Opportunity Dialog',
  JOB_CREATE = 'Job Create',
  JOB_LOCATIONS_OVERVIEW = 'Job Locations Overview',
  OVERVIEW_TIMELINE = 'Overview Timeline',
  BOOK_EVENT_DIALOG = 'Book Event Dialog',
  CREATE_EVENT_DIALOG = 'Create Event Dialog',
  EVENT_ITINERARY = 'Event Itinerary',
  JOB_AGENT = 'Job Agent',
  TIME_TRAVEL = 'Time Travel',
  BOOKING_SCHEDULE = 'Booking Schedule',
  UNSAVED_CHANGES = 'Unsaved Changes',
  QUICK_JS = 'Quick JS',
  RIGHT_PANEL = 'Right Panel',
  DOCUMENTS_MODAL = 'Documents Modal',
  LOCATION_DETAILS_WIZARD = 'Location Details Wizard',
  UNSAVED_CHANGES_BANNER = 'Unsaved Changes Banner',
  NEW_OPPORTUNITY_CUSTOMER = 'New Opportunity Customer',
  CONTROL_META = 'Control Meta Directive',
  NEW_OPPORTUNITY_V4 = 'New Opportunity V4',
  NEW_OPPORTUNITY_LOCATIONS = 'New Opportunity Locations',
  ADD_INVENTORY = 'Add Inventory',
  CANCEL_AND_CLOSE_DIALOG = 'Cancel And Close Dialog',
  DISPATCH_CALENDAR_REMARKS_DIALOG = 'Dispatch Calendar Remarks Dialog',
  BLUESAGE_SETTINGS = 'BlueSage Settings',
  BLUESAGE_QUEUE = 'BlueSage Review Queue',
  BLUESAGE_TERMINAL_PICKER = 'BlueSage Terminal Picker',
  BLUESAGE_TERMINAL_PUSH = 'BlueSage Terminal Push',
  BLUESAGE_REFUND_DIALOG = 'BlueSage Refund Dialog',
  BLUESAGE_REFUND_LEG = 'BlueSage Refund Leg',
  BLUESAGE_PAYMENT_DIALOG = 'BlueSage Payment Dialog',
  CREATE_TRANSACTION_DIALOG = 'Create Transaction Dialog',
  CREATE_DOCUMENT_DIALOG = 'Create Document Dialog',
  DOCUMENT_TYPES = 'Document Types',
  CANCEL_PAY_LINK_DIALOG = 'Cancel Pay Link Dialog',
  CANCEL_PREAUTH_DIALOG = 'Cancel Preauth Dialog',
  USER_PAGE_SIMILAR_CUSTOMERS = 'User Page Similar Customers',
  USER_PAGE_MERGE_CONFLICT_DIALOG = 'User Page Merge Conflict Dialog',
}
